<template>
  <div class="mb-5 mt-4 flex justify-center">
    <img
      src="@/assets/edge-capacity.svg"
      alt="edge capacity logo"
    />
  </div>
  <div class="my-4 mb-8 w-full border-t border-light-gray md:border-none" />
  <layout>
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <div>
        <h3 class="text-left text-3xl text-dark-gray">Create Your Account</h3>
        <progress-indicator
          :current-step="3"
          :length="3"
        />
        <div class="-mt-2 flex justify-between">
          <p class="text-xxs font-bold text-dark-gray">Carrier Search</p>
          <p class="text-xxs font-bold text-dark-gray">General Info</p>
          <p class="text-xxs font-bold text-dark-gray">Get Permission</p>
        </div>

        <h4 class="my-5 text-left text-lg text-dark-gray">
          Request Permission
        </h4>
        <p class="mb-5 text-gray-400">
          For you to be able to onboard this carrier, we need to get an
          authorized representative of the carrier to grant you access. You can
          continue with onboarding in the meantime.
          <span class="text-sm text-yellow-500"> Learn More</span>
        </p>
        <button-main
          type="submit"
          class="mb-4"
          value="Send Request and Continue"
        />
        <button-main
          variant="secondary"
          @click="goBack()"
        >
          Go back
        </button-main>
      </div>
    </form>
  </layout>
</template>

<script>
import Layout from '@/components/LoginLayout.vue';
import ButtonMain from '@/components/Button.vue';
import ProgressIndicator from '@/components/ProgressIndicator.vue';

export default {
  name: 'RequestPermission',
  components: {
    Layout,
    ButtonMain,
    ProgressIndicator,
  },
  data() {
    return {
      company: {},
    };
  },
  computed: {
    carrierName() {
      return this.$store.state.submitButtonDisabled || '';
    },
  },
  methods: {
    handleSubmit() {
      // TODO
    },
    goBack() {
      this.$router.push({
        name: 'DispatcherGeneralInformation',
        params: { canMoveOn: true },
      });
    },
  },
};
</script>
